import React from "react";

// PricingTable Component
const PricingTable = () => {
  const pricingData = [
    {
      id: "forced-air-warming-machine",
      icon: "icofont-machine",
      title: "Forced Air Patient Warming Machine",
      features: [
        "High-quality air circulation",
        "Efficient patient warming technology",
        "Easy-to-use control panel",
        "Portable and space-efficient design",
        "Reliable for long-term use",
      ],
      available: [true, true, true, true, true],
    },
    {
      id: "patient-warming-blanket",
      icon: "icofont-blanket",
      title: "Patient Warming Blanket",
      features: [
        "Soft and comfortable fabric",
        "Ensures optimal body temperature regulation",
        "Lightweight and easy to store",
        "Ideal for use during medical procedures",
        "Safe and effective heating",
      ],
      available: [true, true, true, true, true],
    },
  ];

  return (
    <section className="pricing-table section py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>Your Trusted Source for High-Quality Patient Warming Solutions</h2>
              <img src="img/section-img.png" alt="Section" />
              <p>
                Discover our range of high-quality patient warming products, designed to provide comfort and safety during medical procedures.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          {pricingData.map((pricing) => (
            <div key={pricing.id} className="col-lg-6 col-md-12 col-12">
              <div className="single-table">
                {/* Table Head */}
                <div className="table-head">
                  <div className="icon">
                    <i className={`icofont ${pricing.icon}`}></i>
                  </div>
                  <h4 className="title">{pricing.title}</h4>
                </div>
                {/* Table List */}
                <ul className="table-list">
                  {pricing.features.map((feature, index) => (
                    <li key={index} className={pricing.available[index] ? "" : "cross"}>
                      <i className={`icofont ${pricing.available[index] ? "icofont-ui-check" : "icofont-ui-close"}`}></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                {/* Table Bottom */}
                <div className="table-bottom">
                  <a className="btn" href="tel:+918956322311">
                    Buy Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingTable;
